<template>
  <router-view />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AuthenticationService from "@/apps/person-registration/services/authentication.service";
import MerchantLoginService from "@/apps/merchant3/services/merchant.login.service";
import { getLanguage } from "@/shared-helpers/language.helper";
import { useStore } from "vuex";

export default defineComponent({
  name: "PayJoyApp",
  provide: {
    authenticationService: new AuthenticationService(),
    merchantLoginService: new MerchantLoginService(),
  },
  setup() {
    const store = useStore();
    // Only dispatch if personRegistration module exists (not available in admin-console)
    if (store.hasModule("personRegistration")) {
      store.dispatch("personRegistration/setUserLocation", getLanguage());
      store.dispatch("personRegistration/setUserType", "clerk");
    }
  },
});
</script>
<style lang="scss">
@import "@/assets/scss/global.scss";
.app {
  background-color: white;
}
</style>
